import angular from 'angular';

import PipelineController from './pipelineController';
import PipelineFactory from './pipelineFactory';
import PipelineMappingService from './pipelineMappingsConstant';

// filter
import PipelineFilterModalController from './filter/pipelineFilterModalController';
import PipelineFilterFactory from './filter/pipelineFilterFactory';

// filter/filterOptions
import FilterOptionsDirective from './filter/filterOptions/filterOptionsDirective';

// filterBreadCrumbs
import FilterBreadcrumbsDirective from './filterBreadcrumbs/filterBreadcrumbsDirective';

// job
import PipelineJobModalController from './job/pipelineJobModalController';

// pipelineTable
import PipelineTableController from './pipelineTable/pipelineTableController';
import PipelineTableDirective from './pipelineTable/pipelineTableDirective';

// pipelineTable/projectAdvanceTemplates
import ProjectAdvanceController from './pipelineTable/projectAdvanceTemplates/projectAdvanceController';
import ProjectAdvanceFactory from './pipelineTable/projectAdvanceTemplates/projectAdvanceFactory';

export default angular.module('app.pipeline', [])
    .controller('PipelineController', PipelineController)
    .service('PipelineFactory', PipelineFactory)
    .service('PipelineMappings', PipelineMappingService)

    .controller('PipelineFilterModalController', PipelineFilterModalController)
    .service('PipelineFilterFactory', PipelineFilterFactory)
    .directive('filterOption', FilterOptionsDirective)
    .directive('filterBreadcrumbs', FilterBreadcrumbsDirective)

    .controller('PipelineJobModalController', PipelineJobModalController)

    .controller('PipelineTableController', PipelineTableController)
    .directive('pipelineTable', PipelineTableDirective)

    .controller('ProjectAdvanceController', ProjectAdvanceController)
    .service('ProjectAdvanceFactory', ProjectAdvanceFactory)

    .run(($templateCache) => {
        $templateCache.put('app/pipeline/pipeline.html', require('./pipeline.html')); // eslint-disable-line global-require

        $templateCache.put('app/pipeline/filter/filterOptions/filterOptionsTemplate.html', require('./filter/filterOptions/filterOptionsTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/filter/pipelineFilterModal.html', require('./filter/pipelineFilterModal.html')); // eslint-disable-line global-require

        $templateCache.put('app/pipeline/filterBreadcrumbs/filterBreadcrumbsTemplate.html', require('./filterBreadcrumbs/filterBreadcrumbsTemplate.html')); // eslint-disable-line global-require

        $templateCache.put('app/pipeline/job/pipelineJobDetails.html', require('./job/pipelineJobDetails.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/job/pipelineJobModal.html', require('./job/pipelineJobModal.html')); // eslint-disable-line global-require

        $templateCache.put('app/pipeline/pipelineTable/pipelineLeadsTable.html', require('./pipelineTable/pipelineLeadsTable.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/pipelineTable/pipelineTable.html', require('./pipelineTable/pipelineTable.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceInvoiced.html', require('./pipelineTable/projectAdvanceTemplates/projectAdvanceInvoiced.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvancePaidBack.html', require('./pipelineTable/projectAdvanceTemplates/projectAdvancePaidBack.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvancePastDue.html', require('./pipelineTable/projectAdvanceTemplates/projectAdvancePastDue.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceScheduled.html', require('./pipelineTable/projectAdvanceTemplates/projectAdvanceScheduled.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceSent.html', require('./pipelineTable/projectAdvanceTemplates/projectAdvanceSent.html')); // eslint-disable-line global-require
        $templateCache.put('app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceUnavailable.html', require('./pipelineTable/projectAdvanceTemplates/projectAdvanceUnavailable.html')); // eslint-disable-line global-require

    // $templateCache.put('app/common/spinner/template/defaultSpinnerTemplate.html', require('./template/defaultSpinnerTemplate.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/pipeline/index.js